import { cn } from "../../utils/cn";
import { useEditor } from "./Editor.context";
import { EditorSourceToggle } from "./EditorSourceToggle";
import type { EditorToolbarProps } from "./Editor.types";

const DEFAULT_ACTIONS = [
  { icon: "B", label: "Bold", command: "bold" },
  { icon: "I", label: "Italic", command: "italic" },
  { icon: "U", label: "Underline", command: "underline" },
  { icon: "S", label: "Strikethrough", command: "strikeThrough" },
];

export function EditorToolbar({
  actions = DEFAULT_ACTIONS,
  onAction,
  children,
  className,
  showSourceToggle = true,
}: EditorToolbarProps) {
  const { exec, showSource } = useEditor();

  return (
    <div
      data-react-fancy-editor-toolbar=""
      className={cn(
        "flex shrink-0 items-center gap-0.5 border-b border-zinc-200 px-2 py-1.5 dark:border-zinc-700",
        className,
      )}
    >
      {children ?? (
        <>
          {actions.map((action) => (
            <button
              key={`${action.command}-${action.commandArg ?? ""}`}
              type="button"
              // Rich-text commands don't apply to the raw-source textarea.
              disabled={showSource}
              onClick={() => {
                if (onAction) {
                  onAction(action.command);
                } else {
                  exec(action.command, action.commandArg);
                }
              }}
              title={action.label}
              className={cn(
                "inline-flex h-8 w-8 items-center justify-center rounded-md text-sm transition-colors",
                action.active
                  ? "bg-zinc-200 dark:bg-zinc-700"
                  : "hover:bg-zinc-100 dark:hover:bg-zinc-800",
                showSource && "cursor-not-allowed opacity-40 hover:bg-transparent",
              )}
            >
              {action.icon}
            </button>
          ))}
          {showSourceToggle && <EditorSourceToggle className="ml-auto" />}
        </>
      )}
    </div>
  );
}

EditorToolbar.displayName = "EditorToolbar";
